export default __webpack_public_path__ + "static/media/wildlife03.ccc8490a.png";